import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import Actionable from "../Actionable/index.js";
import styles from "@bookingcom/bui-core/css/Table.module.css";
var TableCell = function (props) {
    var content = props.content, colspan = props.colspan, align = props.align, className = props.className, onClick = props.onClick;
    var cellClassName = classNames(styles.cell, align && styles["cell--align-".concat(align)], className);
    return (React.createElement("td", { className: cellClassName, colSpan: colspan }, onClick ? React.createElement(Actionable, { onClick: onClick }, content) : content));
};
export default TableCell;
